import React from 'react';
import { FormInputWrapper } from '../../styles/common-styles'
import { FormControl,Checkbox, FormControlLabel, FormHelperText, Tooltip, makeStyles} from '@material-ui/core';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import { IndeterminateCheckBox } from '@material-ui/icons';

/**
 * @param {{
 * label: string,
 * labelId: string, 
 * formikValue: Object, 
 * formikChange: Function, 
 * disabled:boolean,
 * errors?: formik.errors.labelId,
 * touched?: formik.touched.labelId,
 * mandatory: Boolean,
 * checked: Boolean,
 * addCheckBoxClass: String 'Add custom class to adjust checkbox'
 * }} props 
 */

const useStyles = makeStyles({
    tooltip: {
      fontSize: '12px' // Set the font size for the tooltip text
    },
  });


export const CheckBoxInput = (props) => {
    const classes = useStyles();
    const { label, indeterminate, labelId, formikValue, formikChange, displayDynamicValue, isDoubled, errors, touched, addCheckBoxClass, disabled, checked, customStyle, isTripple, title, onTooltip, mandatory } = props;
    
    return (
        <FormInputWrapper style={customStyle} className={isDoubled ? 'doubled' : null} isTripple={isTripple ? isTripple : null} isDoubled={isDoubled ? isDoubled : null}>
            <div className={(disabled) ? `disabled ${addCheckBoxClass}` : addCheckBoxClass} >
                <FormControl component="fieldset" className="checkboxInput pointeEvents"> 
                    <Tooltip title={onTooltip && !title ? onTooltip : ""} arrow classes={{ tooltip: classes.tooltip }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    icon={<CheckBoxOutlineBlankOutlinedIcon fontSize="large" />}
                                    checkedIcon={<CheckBoxIcon fontSize="large" />}
                                    name={labelId}
                                    color="primary"
                                    disabled={disabled}
                                    checked={checked}
                                    onChange={formikChange} 
                                    value={formikValue}
                                    title={title}
                                    indeterminate={indeterminate}
                                    indeterminateIcon={<IndeterminateCheckBox fontSize='large' />}
                                    inputProps={{
                                        "aria-required": mandatory ? true : null,
                                        title: title,
                                        "aria-label": label,
                                        "aria-description": title
                                    }}
                                />
                            }
                            label={
                                <>
                                    {label}
                                    {mandatory && (
                                        <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                    )}
                                </>
                            }
                        />
                    </Tooltip>
                </FormControl>
                {displayDynamicValue && <span className={'displayValue'}>{displayDynamicValue}</span>}
                {errors && touched && <FormHelperText className="helperText">{errors}</FormHelperText>}
            </div>
        </FormInputWrapper>
    )
}

export const CheckBoxInputFilter = (props) => {
    const { label, labelId, formikValue, formikChange, isDoubled, errors, touched, checked,disabled } = props;
    return (
        <FormInputWrapper isDoubled={isDoubled ? isDoubled : null}>
            <FormControl component="fieldset" class="pointeEvents">
                <FormControlLabel 
                    control={
                        <Checkbox
                            icon={<CheckBoxOutlineBlankOutlinedIcon fontSize="large" />}
                            checkedIcon={<CheckBoxIcon fontSize="large" />}
                            name={labelId}
                            color="primary"
                            onChange={formikChange} value={formikValue}
                            checked={checked}
                            disabled={disabled}
                        />
                    }
                    label={label}
                />
            </FormControl>
            {errors && touched && <FormHelperText className="helperText">{errors}</FormHelperText>}
        </FormInputWrapper>
    )
}